import {useEffect, useMemo, useRef} from 'react';

import ProductModel from 'coreClasses/product/ProductModel';
import VariantModel from 'coreClasses/product/VariantModel';
import {EEventSource} from 'coreClasses/events/IEvents';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import {ViewItemListEmitter} from 'brandClasses/ViewItemListEmitter';

/**
 * Emits event about products in the user's viewport
 * @param {(ProductModel | VariantModel)[]} products - products
 * @param {EEventSource} source - event source
 * @param {string} categoryId - list category
 */
const useViewItemListEvent = (
	products: (ProductModel | VariantModel)[],
	source?: EEventSource,
	categoryId?: string,
) => {
	const {managerRepository} = useGeneralProvider();
	const currentLocale = managerRepository.getLocalesMgr().getCurrentLocale();
	const country = currentLocale.getCountryCode();
	const eventEmitter = useRef(new ViewItemListEmitter(managerRepository));

	eventEmitter.current.setReadyProducts(products);

	useEffect(() => {
		eventEmitter.current.setCategoryId(categoryId);
		eventEmitter.current.setSource(source);

		return () => {
			// clear all data if the country was changed
			eventEmitter.current.clearAllProductsData();
		};
	}, [country, categoryId]);

	const self = useMemo(
		() => ({
			handleProductVisibility: (productId) => {
				// when the product is in a viewport
				eventEmitter.current.setVisibleProduct(productId);
			},
		}),
		[],
	);

	return self;
};
export default useViewItemListEvent;
